import { DefaultLayout } from '@/layouts/DefaultLayout';

const Settings = () => {
  return (
    <DefaultLayout>
      <div style={{ width: '100%' }}>
        <h2>Configurações de Documentos</h2>
        <p>Funcionalidade de configurações de documentos em desenvolvimento.</p>
      </div>
    </DefaultLayout>
  );
};

export default Settings;




